import { render, staticRenderFns } from "./BioTestingAdminCard.vue?vue&type=template&id=642bbe6d&scoped=true"
import script from "./BioTestingAdminCard.vue?vue&type=script&lang=js"
export * from "./BioTestingAdminCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bbe6d",
  null
  
)

export default component.exports